import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'era-brand',
  templateUrl: './brand.component.html',
  styleUrls: ['./brand.component.scss'],
  imports: [RouterLink],
})
export class BrandComponent {}
